import {Component, inject, signal, ViewEncapsulation} from '@angular/core';
import {BasketUiServiceService} from '../../../../pages/basket/basket-ui-service.service';
import {WishListService} from '../../../../services/wishlist.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgIf} from '@angular/common';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzCheckboxComponent} from 'ng-zorro-antd/checkbox';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent} from 'ng-zorro-antd/form';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective} from 'ng-zorro-antd/input';
import {NzWaveDirective} from 'ng-zorro-antd/core/wave';
import {Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Client} from '../../../../../api/client';
import {JwtService} from '../../../../services/authentication/jwt-service.service';
import {AuthService} from '../../../../services/authentication/auth.service.service';

@Component({
  selector: 'app-login-pop-up',
  imports: [
    ReactiveFormsModule,
    NgIf,
    NzButtonComponent,
    NzCheckboxComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzIconDirective,
    NzInputDirective,
    NzInputGroupComponent,
    NzInputGroupWhitSuffixOrPrefixDirective,
    NzRowDirective,
    NzWaveDirective,
  ],
  templateUrl: './login-pop-up.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './login-pop-up.component.scss'
})
export class LoginPopUpComponent {
  private basket = inject(BasketUiServiceService)
  private wish = inject(WishListService);
  protected dialogRef = inject(MatDialogRef);
  private dialog = inject(MatDialog);
  private client = inject(Client)
  private router = inject(Router);
  private jwtService = inject(JwtService);
  private auth = inject(AuthService);

  loginForm = new FormGroup({
    login: new FormControl<string>(null, [Validators.required]),
    password: new FormControl<string>(null, [Validators.required]),
    remoteIpAddress: new FormControl<string>(null,),
    rememberMe: new FormControl<boolean>(false),
  })

  errorMessage = signal<string>(null)
  isLoading = signal<boolean>(false)
  width = signal<number>(320)
  passwordShow = false;
  errorsStr: {[key: string]: string[]} = {};

  login(): void {
    if (this.loginForm.invalid) {
      return;
    }

    if (!this.checkPhone()) {
      return;
    }

    if (this.loginForm.valid) {
      this.isLoading.set(true)
      this.client.account_Login(this.loginForm.getRawValue()).subscribe({
        next: res => {
          this.jwtService.setTokens(res.accessToken.token, res.refreshToken);
          this.auth.getProfileInfo()
          this.isLoading.set(false)
          this.wish.initWishList()
          this.basket.initBasket()
          this.dialogRef.close()
        },
        error: err => {
          this.isLoading.set(false)
          this.errorMessage.set(err.message)
        }
      })
    }
  }

  checkPhone(): boolean {
    const login = this.loginForm.get('login')?.value || '';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneCharsOnly = /^[0-9+\-*#\s]+$/.test(login);

    if (phoneCharsOnly) {
      const cleaned = login.replace(/-/g, '');
      this.loginForm.get('login')?.setValue(cleaned, { emitEvent: false });

      const prefixes = ['+373'];
      const isValid = prefixes.some(prefix => cleaned.startsWith(prefix));

      if (!isValid) {
        this.width.set(320);
        this.errorMessage.set('Номер телефона должен начинаться с +373 (___)_-__-__');
      }

      return isValid;
    }

    if (!emailRegex.test(login)) {
      this.width.set(320)
      this.errorMessage.set('Неверный формат email адреса');
      return false;
    }

    return true;
  }

  forgotPassword(): void {
    this.dialog.closeAll();
    this.router.navigate(['/forgot-password']);
    setTimeout(() =>{
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },200)

  }
}
